<template>
    <div class="mr-2" v-if="optionsFilter.length && optionsFilter.length > 1">
        <b-dropdown title="Gráficos" variant="link" class="custom-dropdown" ref="optionschart">
            <template #button-content>
                <BarChart2Icon/>
            </template>
            <div class="pl-3 pb-1 dropdown-item" @click="$refs.optionschart.hide()">
                <b-form-checkbox :indeterminate="chekcOptions" :checked="allSelected" @change="toggleAllSelected">
                    Todos
                </b-form-checkbox>
            </div>
            <div v-for="(option, index) in optionsFilter" :key="index" class="pl-4 pb-1 dropdown-item" @click="$refs.optionschart.hide()">
                <b-form-checkbox v-model="selectedOption" :value="option" :disabled="option.disabled">
                    {{ option.text }}
                </b-form-checkbox>
            </div>
        </b-dropdown>
    </div>
</template>

<script>
	import { mapState } from "vuex";
	import { possuiPermissao } from "@/helpers/permissions";

	export default {
		data () {
			return {
				possuiPermissao,
				selectedOption: [],
				optionsFilter: [],
				optionsDashboardView: [
					{
						text: "Totais do mês",
						value: 1,
						perm: "DASHBOARD_V_TOTALS",
						disabled: true,
						checked: true
					},
					{
						text: "Análise comparativa",
						value: 2,
						perm: "DASHBOARD_V_CHART_GERAL"
					},
					{
						text: "Despesas por categorias",
						value: 3,
						perm: "DASHBOARD_V_CHART_CATEGORY"
					},
					{
						text: "Receitas por categorias",
						value: 4,
						perm: "DASHBOARD_V_CHART_CATEGORY_INCOME"
					}
				]
			};
		},

		computed: {
			...mapState(["showCharts"]),
			allSelected () {
				return this.selectedOption.length === this.optionsFilter.length;
			},
			chekcOptions () {
				return this.selectedOption.length > 0 && this.selectedOption.length < this.optionsFilter.length;
			}
		},

		watch: {
			selectedOption () {
				this.$store.commit("setShowCharts", this.selectedOption);

			}
		},

		async mounted () {
			this.getOptionsDashboard();
		},

		methods: {
			toggleAllSelected (checked) {
				if (checked) {
					this.selectedOption = [...this.optionsFilter];
				} else {
					this.selectedOption = this.optionsFilter.filter(ele => ele.checked);
				}
			},
			async getOptionsDashboard () {
				const optionsPermited = this.optionsDashboardView.reduce((acc, opt) => {
					const permission = opt.perm;
					const havePermission = permission ? possuiPermissao(permission) : null;
					if (havePermission || !permission)
						acc.push(opt);

					return acc;
				}, []);

				//this.optionsDashboardViewPermission = optionsPermited.map(ele => ele);
				this.optionsFilter = optionsPermited.map(ele => ele);

				if (this.showCharts && this.showCharts.length) {
					this.selectedOption = [ ...this.showCharts ];
				} else {
					this.selectedOption = optionsPermited.filter(ele => ele.checked);
				}
			}
		}
	};
</script>

<style scoped>

    @media screen and (min-width: 621px) {
        .custom-dropdown >>> .dropdown-toggle {
            background-color: var(--cal-header-color);
        }
    }

	.custom-dropdown >>> .dropdown-item {
		font-family: 'Roboto Condensed Regular' !important;
		font-size: 1rem !important;
		font-weight: 600;
	}

    .custom-dropdown >>> .dropdown-toggle {
        color: white !important;
        font-weight: 600;
        border-radius: 5px;
        height: 48px;
    }
</style>